export default {
    'add-new-visit': 'إضافة زيارة جديدة',
    'message': 'عذرا، لا يوجد خطة تم إنشاؤها',
    'there-is-no-plan-created-for-the-selected-month': 'عذرا، لا يوجد خطة تم إنشاؤها للشهر المحدد',
    'this-visit': 'هذه الزيارة'
}